import { FE_PDP_UX_PHASE2_250514 } from "@faire/retailer-settings/FE_PDP_UX_PHASE2_250514";
import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";

export const useSettingPDPUXPhase2 = (): boolean => {
  return useSetting(FE_PDP_UX_PHASE2_250514);
};
export const useAssignSettingPDPUXPhase2 = () =>
  useAssignSetting(FE_PDP_UX_PHASE2_250514);
